import { useState } from "react";
import { testimonials } from "../../../mocks/home-data";
import FadeIn from "../../../components/base/FadeIn";

export default function Testimonials() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-20 md:py-28 bg-cream-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-16">
              <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-4">
                Müşteri Görüşleri
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Dost Sahipleri{" "}
                <span className="font-serif italic text-primary-700">Ne Diyor?</span>
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                Binlerce mutlu hasta ve sahibi bize güveniyor. İşte bazı gerçek yorumlar.
              </p>
            </div>
          </FadeIn>

          <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
            {/* Left Content */}
            <div className="lg:col-span-3">
              <FadeIn>
                <div className="relative bg-white rounded-3xl p-8 md:p-10 shadow-lg">
                  <i className="ri-double-quotes-l text-5xl md:text-6xl text-primary-200 mb-4 block w-12 h-12" />

                  <blockquote className="text-lg md:text-xl lg:text-2xl font-serif italic text-gray-800 leading-relaxed mb-8">
                    "{testimonials[active].text}"
                  </blockquote>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                        <i className="ri-user-line w-6 h-6 flex items-center justify-center text-primary-600" />
                      </div>
                      <div>
                        <p className="font-bold text-gray-900">{testimonials[active].author}</p>
                        <p className="text-sm text-gray-500">{testimonials[active].pet} sahibi</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-1">
                      {Array.from({ length: testimonials[active].rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-primary-500 w-5 h-5 flex items-center justify-center text-sm" />
                      ))}
                    </div>
                  </div>
                </div>
              </FadeIn>

              {/* Dots */}
              <div className="flex items-center gap-3 mt-8 justify-center lg:justify-start">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActive(i)}
                    className={`h-2.5 rounded-full transition-all duration-300 ${
                      i === active ? "bg-primary-600 w-10" : "bg-primary-200 w-2.5 hover:bg-primary-300"
                    }`}
                    aria-label={`Yorum ${i + 1}`}
                  />
                ))}
              </div>
            </div>

            {/* Right Image */}
            <div className="lg:col-span-2 hidden lg:block">
              <FadeIn delay={0.2} direction="left">
                <div className="relative">
                  <img
                    src="/assets/images/testimonial-person-v3.jpg"
                    alt="Mutlu Müşteri"
                    className="w-full rounded-3xl object-cover aspect-[4/5] shadow-xl"
                  />
                  <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-5 shadow-xl">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                        <i className="ri-heart-fill text-primary-600 w-6 h-6 flex items-center justify-center text-lg" />
                      </div>
                      <div>
                        <p className="text-lg font-bold text-gray-900">5000+</p>
                        <p className="text-sm text-gray-500">Mutlu Dost</p>
                      </div>
                    </div>
                  </div>
                  <div className="absolute -top-4 -right-4 bg-primary-600 rounded-2xl p-4 shadow-xl">
                    <div className="flex items-center gap-2">
                      <i className="ri-star-fill text-yellow-300 w-5 h-5 flex items-center justify-center" />
                      <span className="text-white font-bold text-lg">4.9</span>
                    </div>
                    <p className="text-primary-200 text-xs mt-0.5">Ortalama Puan</p>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}